import { setFullbandMusicMonoAudioProfile } from '@studio/chime/audioVideo/audioVideoHelpers';
import { BROADCAST_UPDATE_CONTENT_SHARE_AUDIO_PROFILE } from 'actions/Types';

/**
 * Optimizing content share audio profile to fullband-music-mono-quality when presenter will be streaming music / audio
 * Referencing Chime SDK Use Case 33: https://github.com/aws/amazon-chime-sdk-js/blob/master/README.md#selecting-an-audio-profile
 * Use the following setting to optimize the audio bitrate of content share audio for fullband music with a mono channel.
 * More details here: https://aws.github.io/amazon-chime-sdk-js/classes/audioprofile.html
 */

export default () => {
  return (dispatch, getState) => {
    const {
      meeting: { meetingSession }
    } = getState();
    const action = {
      type: BROADCAST_UPDATE_CONTENT_SHARE_AUDIO_PROFILE,
      request: async () => {
        setFullbandMusicMonoAudioProfile(meetingSession);
        return true;
      }
    };

    dispatch(action);
  };
};
